import React from 'react';

import { useIntl, defineMessages } from 'react-intl';
import { Button } from '@redturtle/volto-io-studio/components';
import cx from 'classnames';
import config from '@plone/volto/registry';
import { ListingLinkMore } from '@redturtle/volto-io-studio/components/Blocks';
import placeholderSVG from '@redturtle/volto-io-studio/components/Layout/images/placeholder.svg';

import './cardWithStripBlock.less';

const messages = defineMessages({
  seeMore: {
    id: 'seeMore',
    defaultMessage: 'Approfondisci',
  },
});

const CardWithStripBlockTemplate = ({
  items,
  isEditMode,
  linkTitle,
  linkHref,
}) => {
  const intl = useIntl();
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <div id="strip-block">
      <div className="container strip-block-wrapper">
        {items.map((item) => {
          return (
            item && (
              <div className="card-wrapper">
                <div className="card-image">
                  {item.image_field ? (
                    <Image
                      alt={item.title}
                      title={item.title}
                      item={item}
                      responsive={true}
                    />
                  ) : (
                    <Image src={placeholderSVG} />
                  )}
                </div>
                <div className="card-content">
                  <div className="left-side">
                    {item.title && <h3 className="title">{item.title}</h3>}
                    {item.description && <p>{item.description}</p>}
                  </div>
                  {item.getURL && (
                    <div className="button">
                      <Button
                        target="_blank"
                        href={item?.getURL}
                        color="outline"
                        inverted
                        aria-label={cx(
                          intl.formatMessage(messages.seeMore),
                          item.title,
                        )}
                      >
                        {intl.formatMessage(messages.seeMore)}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            )
          );
        })}
        <ListingLinkMore
          linkTitle={linkTitle}
          linkHref={linkHref}
          isEditMode={isEditMode}
        />
      </div>
    </div>
  );
};

export default CardWithStripBlockTemplate;
